<template>
  <form-component>
    <form novalidate="novalidate" @submit.prevent>
      <input-text
        id="name"
        :value="value.name"
        name="name"
        label="Counselor Name"
        type="text"
        @input="val => emitInput('name', val)"
      />
      <label class="replacement-label">SPECIALTIES</label>
      <div class="form-row hide-label">
        <div class="col-12">
          <struggle-picker
            :value="value.struggleIds"
            @input="val => emitInput('struggleIds', val)"
          />
        </div>
      </div>

      <input-datepicker
        id="nextAvailabilityAfter"
        :value="value.nextAvailabilityAfter"
        name="nextAvailabilityAfter"
        label="Availability after"
        type="text"
        :disabled-dates="{ to: moment().toDate() }"
        @input="val => emitInput('nextAvailabilityAfter', val)"
      />

      <input-datepicker
        id="nextAvailabilityBefore"
        :value="value.nextAvailabilityBefore"
        name="nextAvailabilityBefore"
        label="Availability before"
        type="text"
        :disabled-dates="{ to: moment().toDate() }"
        @input="val => emitInput('nextAvailabilityBefore', val)"
      />

      <div class="form-row">
        <div class="col-12">
          <input-select
            id="gender"
            :value="value.gender"
            name="gender"
            label="Gender Identity"
            type="select"
            placeholder="Gender Identity"
            :options="counselorPreferenceGenderOptions"
            @input="val => emitInput('gender', val)"
          />
        </div>
      </div>

      <div class="form-row">
        <div class="col-12">
          <language-picker
            :value="value.languageId"
            @input="val => emitInput('languageId', val)"
          />
        </div>
      </div>

      <div class="form-row">
        <div class="col-12">
          <lgbtq-picker
            :value="value.lgbtq"
            @input="val => emitInput('lgbtq', val)"
          />
        </div>
      </div>

      <div class="form-row">
        <div class="col-12">
          <religion-picker
            :value="value.religion"
            @input="val => emitInput('religion', val)"
          />
        </div>
      </div>

      <div class="form-row">
        <div class="col-12">
          <ethnicity-picker
            :value="value.ethnicity"
            label="Ethnicity"
            @input="val => emitInput('ethnicity', val)"
          />
        </div>
      </div>
    </form>
  </form-component>
</template>

<script>
import FormComponent from '@/components/FormComponent.vue';
import InputText from '@/components/inputs/InputText.vue';
import InputSelect from '@/components/inputs/InputSelect.vue';
import StrugglePicker from '../StrugglePicker.vue';
import InputDatepicker from '@/components/inputs/InputDatepicker.vue';
import LanguagePicker from '../LanguagePicker.vue';
import LgbtqPicker from '../LgbtqPicker.vue';
import ReligionPicker from '../ReligionPicker.vue';
import EthnicityPicker from '../EthnicityPicker.vue';
import FiltersModel from './FiltersModel';
import genderOptions from '@/helpers/mixins/gender-options';
import moment from 'moment';

export default {
  name: 'Filters',

  components: {
    FormComponent,
    InputText,
    InputSelect,
    StrugglePicker,
    InputDatepicker,
    LanguagePicker,
    LgbtqPicker,
    ReligionPicker,
    EthnicityPicker,
  },
  mixins: [genderOptions],
  data() {
    return {
      moment: moment,
    }
  },
  props: {
    value: {
      type: Object,
      default: () => new FiltersModel(),
      require: true
    }
  },

  methods:{
    emitInput(key, val) {
      const filters = new FiltersModel(this.value)
      filters[key] = val;
      this.$emit('input', filters);
    }
  }

};
</script>

<style></style>
